import { useState } from 'react';
import { endpoints } from '../../api';
import { uiText } from '../../i18n';
import type { CircleFormState } from '../studio/circle/CircleFieldInput';
import { clearPhotoResult, readPhotoResult } from '../photo/photo-result-entry';

/** «Сделать рилс» с итога «Фото» (APP-SPEC-5 §16): выбранный вариант встаёт в первый свободный слот лотка.
    Импорт запускает человек; владелец и неизменённая версия исходного заказа проверяются перед upload. */
export function ReelsResultImport({ state }: { state: CircleFormState }) {
  const [error, setError] = useState('');
  const entry = readPhotoResult();
  const slot = state.form?.fields.find(field => field.upload?.kind === 'photo' && !state.inputs[field.key] && !state.uploadIds[field.key]);
  if (!entry || entry.destination !== 'reels' || !slot || state.form?.screen !== 'reels' || state.orderId)
    return error ? <p role="alert">{uiText(error)}</p> : null;
  return (
    <div className="photo-result-import">
      <button
        type="button"
        disabled={state.locked || !state.rights}
        onClick={async () => {
          try {
            const me = await endpoints.me();
            if (me.user.id !== entry.owner) {
              clearPhotoResult(entry);
              throw new Error('owner_changed');
            }
            const source = await endpoints.speech.get(entry.orderId);
            if (source.status !== 'done' || !source.result?.available || source.result_revision !== entry.revision || !source.result.assets.some(asset => asset.index === entry.index))
              throw new Error('source_changed');
            if (await state.upload(slot.key, entry.file)) clearPhotoResult(entry);
            setError('');
          } catch {
            setError('Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.');
          }
        }}
      >
        {uiText('Добавить фото из результата')}
      </button>
      {!state.rights && <small>{uiText('Сначала отметьте согласие на фото')}</small>}
      {error && <p role="alert">{uiText(error)}</p>}
    </div>
  );
}
